import script from "./SensorGroupSensorsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorGroupSensorsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorGroupSensorsView.vue?vue&type=style&index=0&id=8108bc28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8108bc28"]])

export default __exports__